import React from 'react';

const FinalQuotationApprovalButtons = ({ onRoleSelect }) => {
  return (
    <div className="flex gap-4 p-6 justify-center">
      <button
        onClick={() => onRoleSelect('Designer')}
        className="px-6 py-3 bg-yellow-500 text-white font-semibold rounded-lg shadow-md hover:bg-yellow-600 focus:outline-none focus:ring-2 focus:ring-yellow-400 focus:ring-opacity-75 transition-colors"
      >
        Designer
      </button>
      <button
        onClick={() => onRoleSelect('Admin')}
        className="px-6 py-3 bg-green-500 text-white font-semibold rounded-lg shadow-md hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-400 focus:ring-opacity-75 transition-colors"
      >
        Admin
      </button>
      <button
        onClick={() => onRoleSelect('Owner')}
        className="px-6 py-3 bg-red-500 text-white font-semibold rounded-lg shadow-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-75 transition-colors"
      >
        Owner
      </button>
    </div>
  );
};

export default FinalQuotationApprovalButtons;
